//STAND 01.01.2025
export const beitragV = {
  //BEITRAG MÄNNLICH BISEX
  beitragM21: 1.7,
  beitragM22: 1.78,
  beitragM23: 1.84,
  beitragM24: 1.92,
  beitragM25: 2.0,
  beitragM26: 2.06,
  beitragM27: 2.14,
  beitragM28: 2.22,
  beitragM29: 2.3,
  beitragM30: 2.38,
  beitragM31: 2.46,
  beitragM32: 2.56,
  beitragM33: 2.64,
  beitragM34: 2.74,
  beitragM35: 2.84,
  beitragM36: 2.94,
  beitragM37: 3.04,
  beitragM38: 3.16,
  beitragM39: 3.28,
  beitragM40: 3.4,
  beitragM41: 3.52,
  beitragM42: 3.66,
  beitragM43: 3.8,
  beitragM44: 3.94,
  beitragM45: 4.1,
  beitragM46: 4.26,
  beitragM47: 4.44,
  beitragM48: 4.62,
  beitragM49: 4.82,
  beitragM50: 5.02,
  beitragM51: 5.24,
  beitragM52: 5.48,
  beitragM53: 5.72,
  beitragM54: 5.98,
  beitragM55: 6.26,
  beitragM56: 6.56,
  beitragM57: 6.88,
  beitragM58: 7.24,
  beitragM59: 7.6,

  //BEITRAG WEIBLICH BISEX STAND 01.01.2025
  beitragW21: 1.86,
  beitragW22: 1.94,
  beitragW23: 2.02,
  beitragW24: 2.1,
  beitragW25: 2.18,
  beitragW26: 2.26,
  beitragW27: 2.34,
  beitragW28: 2.42,
  beitragW29: 2.5,
  beitragW30: 2.58,
  beitragW31: 2.68,
  beitragW32: 2.76,
  beitragW33: 2.86,
  beitragW34: 2.96,
  beitragW35: 3.06,
  beitragW36: 3.16,
  beitragW37: 3.28,
  beitragW38: 3.4,
  beitragW39: 3.52,
  beitragW40: 3.64,
  beitragW41: 3.76,
  beitragW42: 3.9,
  beitragW43: 4.06,
  beitragW44: 4.2,
  beitragW45: 4.36,
  beitragW46: 4.52,
  beitragW47: 4.7,
  beitragW48: 4.88,
  beitragW49: 5.08,
  beitragW50: 5.28,
  beitragW51: 5.5,
  beitragW52: 5.74,
  beitragW53: 5.98,
  beitragW54: 6.24,
  beitragW55: 6.52,
  beitragW56: 6.8,
  beitragW57: 7.12,
  beitragW58: 7.44,
  beitragW59: 7.8,

  //BEITRAG UNISEX STAND 01.01.2025
  beitragU21: 1.84,
  beitragU22: 1.92,
  beitragU23: 2.0,
  beitragU24: 2.06,
  beitragU25: 2.14,
  beitragU26: 2.22,
  beitragU27: 2.3,
  beitragU28: 2.38,
  beitragU29: 2.46,
  beitragU30: 2.54,
  beitragU31: 2.62,
  beitragU32: 2.72,
  beitragU33: 2.82,
  beitragU34: 2.9,
  beitragU35: 3.02,
  beitragU36: 3.12,
  beitragU37: 3.22,
  beitragU38: 3.34,
  beitragU39: 3.46,
  beitragU40: 3.58,
  beitragU41: 3.72,
  beitragU42: 3.84,
  beitragU43: 4.0,
  beitragU44: 4.14,
  beitragU45: 4.3,
  beitragU46: 4.46,
  beitragU47: 4.64,
  beitragU48: 4.82,
  beitragU49: 5.02,
  beitragU50: 5.22,
  beitragU51: 5.44,
  beitragU52: 5.68,
  beitragU53: 5.92,
  beitragU54: 6.18,
  beitragU55: 6.46,
  beitragU56: 6.74,
  beitragU57: 7.06,
  beitragU58: 7.4,
  beitragU59: 7.76,
}
//exports.beitragV = beitragV;
